import {
  CropResidue,
  FieldDetails,
  LandChanges,
} from 'models/Farmbox/field.model';

export const stage4InitialData = async (
  commodityId: string | undefined,
  fetchFieldData: (pathParams: {
    commodityId?: string;
  }) => Promise<FieldDetails | undefined>
) => {
  const initialValues: FieldDetails | undefined = await fetchFieldData({
    commodityId,
  });
  let defaultValues = initialValues?.commodity
    ? { ...new FieldDetails(), ...initialValues }
    : new FieldDetails();

  if (defaultValues.commodity) {
    defaultValues.commodity.cropResidues = defaultValues.commodity.cropResidues
      ?.length
      ? defaultValues.commodity.cropResidues
      : [new CropResidue()];

    defaultValues.commodity.landUseChanges = defaultValues.commodity
      .landUseChanges?.length
      ? defaultValues.commodity.landUseChanges
      : [new LandChanges()];

    defaultValues.commodity.landManagementChanges = defaultValues.commodity
      .landManagementChanges?.length
      ? defaultValues.commodity.landManagementChanges
      : [new LandChanges()];
  }

  return defaultValues;
};
